// Point the browser tab icon + home-screen icon at the tenant's derived icons (favicon /
// apple-touch PNGs). Türetilmiş ikon yoksa önce kare simgeye, o da yoksa ham logoya düşer —
// sekmedeki 16-32px'te geniş kilit okunmadığı için simge logodan önce geliyor.
export const setFavicon = ({ favicon, appleTouch, markUrl, logoUrl } = {}) => {
  const fallback = markUrl || logoUrl;
  const targets = [
    ["icon", favicon || fallback],
    ["apple-touch-icon", appleTouch || fallback],
  ];
  for (const [rel, href] of targets) {
    if (!href) {
      continue;
    }
    let link = document.querySelector(`link[rel="${rel}"]`);
    if (!link) {
      link = document.createElement("link");
      link.rel = rel;
      document.head.appendChild(link);
    }
    link.href = href;
  }
};
